import { render } from "./WeightChart.vue?vue&type=template&id=72cf7ae4"
import script from "./WeightChart.vue?vue&type=script&lang=js"
export * from "./WeightChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__